'use client'

// src/hooks/useEmailSpelling.ts
import { useMemo } from "react";
import emailSpellChecker from "@zootools/email-spell-checker";
var useEmailSpelling = ({ email }) => {
  const emailSuggestion = useMemo(() => {
    if (email) {
      return emailSpellChecker.run({
        email,
        domains: [
          ...emailSpellChecker.POPULAR_DOMAINS,
          "uxbert.com",
          "supertech.sa",
          "gov.sa",
          "edu.sa",
          "com.sa",
          "sdaia.gov.sa",
          "moi.gov.sa",
          "mcit.gov.sa",
          "mofa.gov.sa",
          "mc.gov.sa",
          "mep.gov.sa",
          "hrsd.gov.sa",
          "moj.gov.sa",
          "mewa.gov.sa",
          "mof.gov.sa",
          "hotmail.com"
        ],
        topLevelDomains: [...emailSpellChecker.POPULAR_TLDS, "sa", "com.sa", "gov.sa"]
      });
    }
  }, [email]);
  return emailSuggestion;
};

export {
  useEmailSpelling
};
//# sourceMappingURL=chunk-X3QLCDDI.mjs.map